export default __webpack_public_path__ + "static/media/default_header.1753b927.svg";